import { Routes } from "@angular/router";
import { AuthLayoutComponent } from "./shared/layouts/auth-layout/auth-layout.component";
import { DashboardLayoutComponent } from "./shared/layouts/dashboard-layout/dashboard-layout.component";
import { AuthGuard } from "./shared/services/guard.service";

export const APP_ROUTES: Routes = [
    {
        path: "authentication",
        component: AuthLayoutComponent,
        loadChildren: () => import("./modules/authentication/auth.routes").then((m) => m.AUTH_ROUTES),
    },
    {
        path: "",
        canActivate: [AuthGuard],
        component: DashboardLayoutComponent,
        loadChildren: () => import("./modules/dashboard/dashboard.routes").then((m) => m.DASHBOARD_ROUTES),
    },
    {
        path: "**",
        redirectTo: "authentication/login",
    },
];
